// http://stackoverflow.com/a/27691108
/** Expects `?` as first character of querystring argument. Returns empty object if `qs` parameter is undefined. */
export function qsToObject(qs) {
  if (!qs) {
    return {};
  }
  const hashes = qs.slice(qs.indexOf('?') + 1).split('&');
  const params = {};
  hashes.map(hash => {
    const param = hash.split('=');
    const key = param.shift();
    const val = param.join('=');
    params[key] = decodeURIComponent(val);
  });
  return params;
}
export function objectToQs(params) {
  return Object.keys(params).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&');
}